import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/info/:id',
    name: 'info',
    component: () => import(/* webpackChunkName: "info" */ '../views/Info.vue')
  },
  {
    path: '/add',
    name: 'add',
    component: () => import(/* webpackChunkName: "add" */ '../views/Add.vue')
  },
  {
    path: '/edit/:id',
    name: 'edit',
    component: () => import(/* webpackChunkName: "edit" */ '../views/Edit.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "user" */ '../views/User.vue')
  },
  {
    path: '/records',
    name: 'records',
    component: () => import(/* webpackChunkName: "records" */ '../views/Records.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 保存微信入口URL，用于JSSDK签名（SPA history模式下必须使用入口URL）
sessionStorage.setItem('wx_landing_url', window.location.href.split('#')[0])

router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    return next()
  }
  if (localStorage.getItem('is_login')) {
    return next()
  }
  next({ path: '/login', query: to.query })
})

export default router
